import React from 'react'

export default function Account() {
    return (
        <div>
            <h1>Account Route</h1>
        </div>
    )
}
